<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>经销商消费列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="5">
          <el-input placeholder="请输入订单号" v-model="queryInfo.order_id" clearable @clear="getOrderList">
            <!-- <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button> -->
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.agencyName" clearable @clear="getOrderList">
            <!-- <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button> -->
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.jxtype" placeholder="类型">
                <el-option
                  v-for="item in jxtypelist"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="searchOrder">搜索</el-button>
          <!-- <div class="tip">添加低温商品前，请先设置截止时间</div> -->
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker
              v-model="queryInfo.time"
              @change="timechange"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </el-col>

        <el-col :span="4" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time) + '&order_id=' + queryInfo.order_id + '&agencyName=' + queryInfo.agencyName + '&jxtype='+queryInfo.jxtype">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="订单号" prop="order_id" width="130px"></el-table-column>
        <el-table-column label="经销商" prop="agencyName" width="130px"></el-table-column>
        <el-table-column label="金额" prop="money" align="center" width="80px"> </el-table-column>
        <el-table-column label="类型" prop="typeTxt" align="center" width="80px"> </el-table-column>
        <!-- 充值余额，授信余额，冻结余额 -->
        <el-table-column label="余额账户" prop="payWithMoney" align="center" width="80px"> </el-table-column>
        <el-table-column label="授信账户" prop="payWithCredit" align="center" width="80px"> </el-table-column>
        <el-table-column label="返点账户" prop="payWithRefund" align="center" width="80px"> </el-table-column>
        <el-table-column label="设备补贴账户" prop="payWithSubsidy" align="center" width="120px"> </el-table-column>
        <el-table-column label="冻结账户" prop="payWithDongjie" align="center" width="80px"> </el-table-column>
        <el-table-column label="收支状态" prop="beizhu" align="center" width="90px">
          <!-- <template slot-scope="scope" v-if="scope.row.type != '6'">
            <div>{{ scope.row.typeTxt }}</div>
          </template>
          <template slot-scope="scope" v-if="scope.row.type == '6'">
            <div>{{ scope.row.beizhu }}</div>
          </template> -->
        </el-table-column>

        <el-table-column label="审核状态" width="140px">
          <!-- 0是常温订单支付，1是订单退款，2是充值 3.预约订单支付 4预约订单确认 5预约订单减少数量，不计入消费6账户冲正 -->
          <template slot-scope="scope" v-if="scope.row.type == '2'">
            <el-tag type="warning" v-if="scope.row.status == '0'">待审核</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.status == '1'">审核通过</el-tag>
            <el-tag class="daifahuo" v-if="scope.row.status == '2'">拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="create_at" width="130px">
          <template slot-scope="scope">
            {{ scope.row.create_at | dateFormat }}
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      canLook: 1,
      exportUrl: 'https://hsapi.hsxsn.cn//jxsComsumeList?mPhone=' + localStorage.getItem('phone'),
      // exportUrl: 'http://huangshi-localhost/jxsComsumeList?mPhone=' + localStorage.getItem('phone'),
      queryInfo: {
        agencyName: '',
        order_id: '',
        pagenum: 1,
        pagesize: 10,
        time: null,
        jxtype: '',
      },
      statusValue: '全部',
      // 审核状态0未审核，1审核通过2拒绝
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '未审核', id: 0 },
        { value: '审核通过', id: 1 },
        { value: '拒绝', id: 2 },
      ],
      typeValue: '全部',
      typeOptions: [
        { value: '全部', id: 0 },
        { value: '常温', id: 1 },
        { value: '低温', id: 2 },
      ],
      jxtypelist:[
          {id:'',label:'全部'},
          {id:10,label:'订单支付'},
          {id:1,label:'订单退款'},
          {id:2,label:'充值'},
          {id:3,label:'冻结账户'},
          {id:4,label:'预约订单已确认，冻结账户扣款'},
          {id:5,label:'预约订单修改数量，冻结账户扣款'},
          {id:6,label:'账户冲正'},
        ],
      total: 0,
      orderlist: [],
      progressVisible: false,
      progressInfo: [],
      multipleSelection: [],
      multipleSelectionjson: null,
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {

    searchOrder () {
      this.filterSelect();
    },

    timechange (e) {
      this.filterSelect();
    },

    // 编辑
    editOrder (id) {
      console.log(id);
      this.$router.push({ path: '/orders/detail', query: { id: id } })
    },

    // 删除
    async deleteOrder (id) {
      const confirmResult = await this.$confirm(
        '订单删除后将不可找回,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delete', {
        id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('删除订单失败！')
      }
      this.$message.success('删除订单成功！')
      this.getOrderList()
    },


    filterSelect () {
      this.queryInfo.pagenum = 1
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsapi.hsxsn.cn//jxsComsumeList?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.hsxsn.cn//jxsComsumeList?mPhone=' + localStorage.getItem('phone')
      }
    },

    async getOrderList () {
      console.log(this.queryInfo)
      const { data: res } = await this.$http.get('admin/users/getAlljxsComsumeList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}
</style>
